export const UNSECURED_VERTICAL_APPS_ENABLED_KEY = 'prophecy.ui.unsecured.verticalApps.enabled';
export const UNSECURED_PDF_ANALYSIS_ENABLED_KEY = 'prophecy.ui.unsecured.pdfAnalysis.enabled';
export const UNSECURED_UNIFIED_METRICS_ENABLED_KEY = 'prophecy.ui.unsecured.telemetry.events.enabled';
export const UNSECURED_SSO_AUTO_LOGIN_DISABLED_KEY = 'prophecy.ui.unsecured.ssoAutoLogin.disabled';
